import React from 'react';
import { kpis } from '../lib/data';
type Metric = {
  label: string;
  value: string;
  tone?: 'consent' | 'attention' | 'ink';
  caption?: string;
};
const metrics: Metric[] = [{
  label: 'POSTES À ACTIONNER',
  value: String(kpis.postsToAction)
}, {
  label: 'CANDIDATS CONSENTIS EN ATTENTE',
  value: String(kpis.consentedWaiting),
  tone: 'consent'
}, {
  label: "SUIVIS D'INTÉGRATION DUS",
  value: String(kpis.onboardingDue),
  tone: 'attention'
},
// Le chiffre que seul Talenxia peut afficher : la boucle est mesurée.
{
  label: 'PRÉCISION DE PRÉDICTION',
  value: kpis.predictionAccuracy,
  tone: 'ink',
  caption: kpis.predictionBase
}];
function dotClass(tone: Metric['tone']) {
  if (tone === 'consent') return 'bg-consent';
  if (tone === 'attention') return 'bg-attention';
  return 'bg-ink';
}
export function KPIRow() {
  return <section className="mx-auto grid w-full max-w-6xl grid-cols-2 gap-px overflow-hidden rounded-card border border-line bg-line sm:grid-cols-4" data-id="element-183" data-mp="1i67avupz7j7n">
      {metrics.map(metric => <article key={metric.label} className="min-h-[130px] bg-white px-4 py-4 sm:px-5" data-id="element-184" data-mp="mhgeehbaitjo">
          <p className="flex min-h-[26px] items-start gap-1.5 text-[10px] font-600 leading-[1.3] tracking-[0.09em] text-muted" data-id="element-185" data-mp="rfrngptrh00u">
            {metric.tone && <span className={`mt-0.5 h-1.5 w-1.5 flex-none rounded-full ${dotClass(metric.tone)}`} data-id="element-186" data-mp="116mb9ymno7oe" />}
            {metric.label}
          </p>
          <p className="mt-3 font-serif text-[31px] font-400 leading-none tracking-[-0.02em] text-ink" data-id="element-187" data-mp="3kyf9eu43rde">
            {metric.value}
          </p>
          {metric.caption && <p className="mt-2 text-[11px] leading-snug text-muted" data-id="element-188" data-mp="dh1ot5ramsad">{metric.caption}</p>}
        </article>)}
    </section>;
}